import styled from 'styled-components';
import Column from './column';

const InnerColumn = styled(Column)`
  flex-direction: column;
`;
export default InnerColumn;
